import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import { getTestIds } from 'seagull/utils/TestIds';
import { draftLogicTextsPath } from '~/business-logic/draftLogic';
import { useValidationRules } from '~/hooks/useValidationRules/useValidationRules';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../../EditableTableCell/EditableTableCell';
import { clientAdditionalRecipientsModalOptions, recipientsCellAvailability } from './AdditionalRecipientsCell.utils';
export const GetAdditionalRecipientsCellTID = (parentTestId)=>getTestIds(parentTestId);
export function AdditionalRecipientsCell(param) {
    let { draft, contact, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { AdditionalRecipientsCellTestIds } = GetAdditionalRecipientsCellTID();
    const { t: draftCellsTexts } = useLocaleKeys('proposal.draftsDashboard.cells');
    const { t: validationTexts } = useLocaleKeys(draftLogicTextsPath);
    const validators = useValidationRules();
    const numReviewers = draft.reviewers().length;
    const availability = recipientsCellAvailability({
        draft,
        contact,
        isDisabled,
        disabledTooltip,
        draftCellsTexts: draftCellsTexts.draft
    });
    const openRecipientsModal = ()=>onOpenModal(clientAdditionalRecipientsModalOptions({
            title: draftCellsTexts.draft.additionalRecipients(),
            testId: AdditionalRecipientsCellTestIds.ClientModal(),
            primaryContact: contact || undefined,
            validationTexts,
            validators
        }));
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: AdditionalRecipientsCellTestIds.Root(index),
        isDisabled: availability.isDisabled,
        disabledTooltip: availability.disabledTooltip,
        onClick: openRecipientsModal,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: AdditionalRecipientsCellTestIds.Count(index),
            skin: numReviewers ? 'standard' : 'secondary',
            children: numReviewers ? draftCellsTexts.shared.additionalRecipientsCount({
                count: numReviewers
            }) : draftCellsTexts.shared.notSet()
        })
    });
}
